export const STEP = {
  STEP_1: 1,
  STEP_2: 2,
  STEP_3: 3,
  STEP_4: 4,
} as const;

export type Step = (typeof STEP)[keyof typeof STEP];

export const AUTH_TYPE = {
  SMS_OTP: "1",
  MCODE_OTP: "3",
  SIGNATURE: "7",
};

export type IAuthType = (typeof AUTH_TYPE)[keyof typeof AUTH_TYPE];

export const MODE = {
  SMARTOTP_PUSH: "SMS_PUSH",
  SMARTOTP_CODE: "SMS_OTP",
};

export type IMode = (typeof MODE)[keyof typeof MODE];
